import _ from 'lodash';
import * as React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import styles from './index.module.css';

import * as api from '../../api';

import LabeledInput from '../LabeledInput';
import PhoneInput from '../PhoneInput';
import { SelectInput } from '../SelectInput';
import { getOptionsFromRecord } from '../utils';
import { TextInput } from './TextInput';

const { Primitive } = api.PrevisitFormTemplateFieldConfig;

interface Props extends WithTranslation {
  emergencyContactRelationships: api.Patient.EmergencyContactRelationship[];
  primitive:
    | api.PrevisitFormTemplateFieldConfig.Primitive.PatientEmergencyContact
    | api.PrevisitFormTemplateFieldConfig.Primitive.PatientRelativeEmergencyContact;
  saveFieldValue: (value: string) => void;
  updateFieldValue: (value: string) => void;
  value?: string;
}

interface State {}

class EmergencyContact extends React.Component<Props, State> {
  render() {
    const {
      emergencyContactRelationships,
      primitive,
      saveFieldValue,
      updateFieldValue,
      value,
      t,
    } = this.props;

    const emergencyFirstNameId = 'emergency-first-name';
    const emergencyLastNameId = 'emergency-last-name';
    const emergencyRelationshipId = 'emergency-relationship';
    const emergencyRelationshipToContact = 'emergency-relationship-to-contact';
    const emergencyPhoneId = 'emergency_phone';
    const oldContact = value ? JSON.parse(value) : {};
    const {
      emergencyContactFirstName,
      emergencyContactLastName,
      emergencyContactPhone,
      emergencyContactRelationship,
      patientRelationshipToEmergencyContact,
    } = oldContact;

    const selectOptions = emergencyContactRelationships.length
      ? _.pick(api.Previsit.relationshipMap, emergencyContactRelationships)
      : api.Previsit.relationshipMap;
    const contactUpdate = (update: { [key: string]: string }) => {
      let newValue = { ...oldContact, ...update };
      const anyFilled = _.some(newValue, (val) => !!val);
      return anyFilled ? JSON.stringify(newValue) : '';
    };

    return (
      <div className={styles.EmergencyContact}>
        <LabeledInput label={t('firstName')} htmlFor={emergencyFirstNameId}>
          <TextInput
            id={emergencyFirstNameId}
            value={emergencyContactFirstName || ''}
            updateFieldValue={(newValue) =>
              updateFieldValue(
                contactUpdate({ emergencyContactFirstName: newValue }),
              )
            }
            saveFieldValue={(newValue) =>
              saveFieldValue(
                contactUpdate({ emergencyContactFirstName: newValue }),
              )
            }
          />
        </LabeledInput>
        <LabeledInput label={t('lastName')} htmlFor={emergencyLastNameId}>
          <TextInput
            id={emergencyLastNameId}
            value={emergencyContactLastName || ''}
            updateFieldValue={(newValue) =>
              updateFieldValue(
                contactUpdate({ emergencyContactLastName: newValue }),
              )
            }
            saveFieldValue={(newValue) =>
              saveFieldValue(
                contactUpdate({ emergencyContactLastName: newValue }),
              )
            }
          />
        </LabeledInput>
        {primitive === Primitive.PatientEmergencyContact ? (
          <LabeledInput
            label={t('Relationship')}
            htmlFor={emergencyRelationshipId}
          >
            <SelectInput
              id={emergencyRelationshipId}
              onChange={(newValue: string) => {
                updateFieldValue(
                  contactUpdate({ emergencyContactRelationship: newValue }),
                );
                saveFieldValue(
                  contactUpdate({ emergencyContactRelationship: newValue }),
                );
              }}
              options={getOptionsFromRecord(selectOptions)}
              value={emergencyContactRelationship || ''}
            />
          </LabeledInput>
        ) : (
          <LabeledInput
            label={t('patientRelationshipToContact')}
            htmlFor={emergencyRelationshipToContact}
          >
            <SelectInput
              id={emergencyRelationshipToContact}
              onChange={(newValue: string) => {
                updateFieldValue(
                  contactUpdate({
                    patientRelationshipToEmergencyContact: newValue,
                  }),
                );
                saveFieldValue(
                  contactUpdate({
                    patientRelationshipToEmergencyContact: newValue,
                  }),
                );
              }}
              options={getOptionsFromRecord(selectOptions)}
              value={patientRelationshipToEmergencyContact || ''}
            />
          </LabeledInput>
        )}
        <LabeledInput label={t('phoneNumber')} htmlFor={emergencyPhoneId}>
          <PhoneInput
            label={t('phoneNumber')}
            id={emergencyPhoneId}
            value={emergencyContactPhone || ''}
            placeholder={t('avoidUsingPatientsPhoneNumber')}
            updateFieldValue={(newValue) =>
              updateFieldValue(
                contactUpdate({ emergencyContactPhone: newValue }),
              )
            }
            saveFieldValue={(newValue) =>
              saveFieldValue(contactUpdate({ emergencyContactPhone: newValue }))
            }
          />
        </LabeledInput>
      </div>
    );
  }
}

export default withTranslation()(EmergencyContact);
